import { BooleanFormType } from "Store/interfaces/FormTypes";
import { UserIdentificationData } from "Store/userIdentification";
import { formBooleanToBoolean } from "Utils/formUtils";

const HIGH_RISK_BRANDS = ["BMW", "AUDI", "MERCEDES-BENZ"];
const HIGH_RISK_YEAR = 30;
const FALLBACK_AGE_IF_UNDEFINED = 100;
const CAR_FIVE_YEARS_OLD = 5;
const CAR_TEN_YEARS_OLD = 10;

export const showIsCarTrimmed = (
  brand: string,
  year: string,
  userIdentification: UserIdentificationData | null,
  usedByYoungerDriver: BooleanFormType,
): boolean => {
  const isHighRiskBrand = HIGH_RISK_BRANDS.includes(brand.toUpperCase());
  const ageNumber = userIdentification
    ? Number(userIdentification.newCustomerResponse.age)
    : FALLBACK_AGE_IF_UNDEFINED;

  if (Number.isNaN(Number(year))) {
    return true;
  }

  const carAge = new Date().getFullYear() - Number(year);

  const isHighRiskYearCondition =
    (ageNumber <= HIGH_RISK_YEAR && carAge > CAR_FIVE_YEARS_OLD) ||
    (ageNumber > HIGH_RISK_YEAR &&
      formBooleanToBoolean(usedByYoungerDriver) &&
      carAge > CAR_TEN_YEARS_OLD);

  return isHighRiskYearCondition && isHighRiskBrand;
};
